import {
    USER_DETAILS_FAIL,
    USER_DETAILS_REQUEST,
    USER_DETAILS_RESET,
    USER_DETAILS_SUCCESS,
    USER_FORGOT_FAIL,
    USER_FORGOT_REQUEST,
    USER_FORGOT_RESET,
    USER_FORGOT_SUCCESS,
    USER_LIST_FAIL,
    USER_LIST_REQUEST,
    USER_LIST_SUCCESS,
    USER_REGISTER_FAIL,
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_RESET_FAIL,
    USER_RESET_REQUEST,
    USER_RESET_RESET,
    USER_RESET_SUCCESS,
    USER_SIGNIN_FAIL,
    USER_SIGNIN_REQUEST,
    USER_SIGNIN_SUCCESS,
    USER_SIGNOUT,
    USER_TOPSELLER_LIST_FAIL,
    USER_TOPSELLER_LIST_REQUEST,
    USER_TOPSELLER_LIST_SUCCESS,
    USER_UPDATE_FAIL,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_RESET,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_REQUEST,
    USER_UPDATE_RESET,
    USER_UPDATE_SUCCESS,
} from "../constants/userConstants";

export const userSigninReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_SIGNIN_REQUEST:
            return { loading: true };
        case USER_SIGNIN_SUCCESS:
            return { loading: false, userInfo: action.payload };
        case USER_SIGNIN_FAIL:
            return { loading: false, error: action.payload };
        case USER_SIGNOUT:
            return {};
        default:
            return state;
    }
};

export const userRegisterReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_REGISTER_REQUEST:
            return { loading: true };
        case USER_REGISTER_SUCCESS:
            return { loading: false, userInfo: action.payload };
        case USER_REGISTER_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const userDetailsReducer = (state = { loading: true }, action) => {
    switch (action.type) {
        case USER_DETAILS_REQUEST:
            return { loading: true };
        case USER_DETAILS_SUCCESS:
            return { loading: false, user: action.payload };
        case USER_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case USER_DETAILS_RESET:
            return { loading: true };
        default:
            return state;
    }
};

export const userUpdateProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_UPDATE_PROFILE_REQUEST:
            return { loading: true };
        case USER_UPDATE_PROFILE_SUCCESS:
            return { loading: false, success: true };
        case USER_UPDATE_PROFILE_FAIL:
            return { loading: false, error: action.payload };
        case USER_UPDATE_PROFILE_RESET:
            return {};
        default:
            return state;
    }
};

export const userUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_UPDATE_REQUEST:
            return { loading: true };
        case USER_UPDATE_SUCCESS:
            return { loading: false, success: true };
        case USER_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case USER_UPDATE_RESET:
            return {};

        default:
            return state;
    }
};

export const userListReducer = (state = { loading: true }, action) => {
    switch (action.type) {
        case USER_LIST_REQUEST:
            return { loading: true };
        case USER_LIST_SUCCESS:
            return { loading: false, users: action.payload };
        case USER_LIST_FAIL:
            return { loading: false, error: action.payload };

        default:
            return state;
    }
};

export const userTopSellerListReducer = (state = { loading: true }, action) => {
    switch (action.type) {
        case USER_TOPSELLER_LIST_REQUEST:
            return { loading: true };
        case USER_TOPSELLER_LIST_SUCCESS:
            return { loading: false, users: action.payload };
        case USER_TOPSELLER_LIST_FAIL:
            return { loading: false, error: action.payload };

        default:
            return state;
    }
};

export const passwordForgotReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_FORGOT_REQUEST:
            return { loading: true };
        case USER_FORGOT_SUCCESS:
            return { loading: false, success: true, userInfo: action.payload };
        case USER_FORGOT_FAIL:
            return { loading: false, error: action.payload };
        case USER_FORGOT_RESET:
            return {};
        default:
            return state;
    }
};

export const passwordResetReducer = (state = {}, action) => {
    switch (action.type) {
        case USER_RESET_REQUEST:
            return { loading: true };
        case USER_RESET_SUCCESS:
            return { loading: false, success: true, userInfo: action.payload };
        case USER_RESET_FAIL:
            return { loading: false, error: action.payload };
        case USER_RESET_RESET:
            return {};
        default:
            return state;
    }
};
